import DataSourceController from '@/views/fusion/investment/intelligence-create/controller/DataSourceController';
import store from '@/store';
import { transformTreeKey } from '@/tools/form';
import { getDeliveryContentApi } from '@/api/tool/delivery-content';
import { getConvertGoalListApi } from '@/api/tool/convert-goal';
import { getDeepConvertGoalApi } from '@/api/tool/deep-convert-goal';
import { getBusinessCategoryListApi } from '@/api/tool/business-category';
import { getStoryComponentListApi } from '@/api/tool/story-component';

/**
 * 管理B站渠道的数据
 */
export default class BilibiliDataSourceController extends DataSourceController {
  /**
   * 获取投放内容
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeliveryContentById(advertiser_id, filtering = {}) {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const params = {
        channel_interface,
        advertiser_id,
        filtering,
      };
      const ret = await getDeliveryContentApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: `${name}（${id}）`, value: `${id}#${name}` }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取投放类型枚举
   */
  async getSpeedModeEnums() {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const data = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_speed_mode : [];
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取优化目标列表
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getConvertGoalList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getConvertGoalListApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取深度优化目标列表
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeepConvertGoalList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getDeepConvertGoalApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取深度优化方式枚举
   * @returns {Promise<Object[]>}
   */
  async getDualBidTwoStageOptimizationEnums() {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const data = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_dual_bid_two_stage_optimization : [];
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取Story转化组件列表
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getStoryComponentList(advertiser_id, filtering = {}) {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const params = {
        channel_interface,
        advertiser_id,
        ...filtering,
      };
      const ret = await getStoryComponentListApi(params);
      const result = (ret?.list || []).map(({ component_id, component_name }) => ({ label: `${component_name}（${component_id}）`, value: `${component_id}#${component_name}` }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取创意分类列表
   * @returns {Promise<Object[]>}
   */
  async getBusinessCategoryList() {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
      };
      const ret = await getBusinessCategoryListApi(params);
      // 只需要【游戏】分类的数据
      const result = (ret?.list || []).filter(({ value }) => value === 1);
      const options = transformTreeKey({ options: result });
      return Promise.resolve(options);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取选择按钮枚举表
   */
  async getButtonIdEnumsMap() {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const video_button_id = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_video_button_id : [];
      const image_button_id = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_image_button_id : [];
      const map = {
        // 视频类型选择按钮
        4: video_button_id,
        // 图片类型选择按钮
        1: image_button_id,
      };
      return Promise.resolve(map);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
